import { Size } from '../../primitives/size';
import { DrawingElement } from './drawing-element';
import { measureImage } from './../../utility/dom-util';
/**
 * ImageElement defines a basic image elements
 */
export class ImageElement extends DrawingElement {
    /**
     * set the id for each element
     */
    constructor() {
        super();
        /**
         * sets or gets the image source
         */
        this.imageSource = '';
        /**
         * sets or gets the print id
         * @private
         */
        this.printID = '';
        /**
         * sets scaling factor of the image
         */
        this.imageScale = 'None';
        /**
         * sets the alignment of the image
         */
        this.imageAlign = 'None';
        /**
         * Sets how to stretch the image
         */
        this.stretch = 'Stretch';
    }
    /**
     * Gets the source for the image element
     */
    get source() {
        return this.imageSource;
    }
    /**
     * Sets the source for the image element
     */
    set source(value) {
        this.imageSource = value;
        this.isDirt = true;
    }
    /**
     * Measures minimum space that is required to render the image
     * @param availableSize
     */
    measure(availableSize) {
        if (this.isDirt && (this.stretch !== 'Stretch' || this.width === undefined && this.height === undefined)) {
            this.contentSize = measureImage(this.source, this.contentSize);
            this.isDirt = false;
        }
        if (this.width !== undefined && this.height !== undefined) {
            this.desiredSize = new Size(this.width, this.height);
            this.contentSize = this.desiredSize;
        }
        else {
            this.desiredSize = this.contentSize;
        }
        this.desiredSize = this.validateDesiredSize(this.desiredSize, availableSize);
        return this.desiredSize;
    }
    /**
     * Arranges the image
     * @param desiredSize
     */
    arrange(desiredSize) {
        this.actualSize = new Size(this.desiredSize.width, this.desiredSize.height);
        this.updateBounds();
        return this.actualSize;
    }
}
